import React, { useState, useEffect } from 'react';
import { SmartContainer, Stack } from '../../styles/Containers';
import { NewContentButton } from './NewContentButton';
import { NewContentForm } from './NewContentForm';
import { StyledModal } from '../../styles/matieralui/Modal';
import { StyledP } from '../../styles/StyledHTML';

export const NewContent = ({ buttonText, iconHelperText, label, selector, createAction, titleLabel = "Title", helper = "Enter a title", children, args }) => {

    const [open, setOpen] = useState(false);
    const store = selector();

    useEffect(() => {
        if (store.createSuccess) setOpen(false);
    }, [store?.createLoading])

    return (
        <SmartContainer>
            <SmartContainer flex align="center" justify="center" direction="column">
                <NewContentButton buttonText={buttonText} onClick={() => setOpen(true)} />
                {iconHelperText && (<StyledP light>{iconHelperText}</StyledP>)}
            </SmartContainer>
            <StyledModal open={open} onClose={() => setOpen(false)} label={label}>
                <Stack>
                    {!children && (<NewContentForm titleLabel={titleLabel} helper={helper} selector={selector} createAction={createAction} args={args} />)}
                    {children}
                </Stack>
            </StyledModal>
        </SmartContainer>
    )
}